<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">汇辰学院</el-breadcrumb-item>
      <el-breadcrumb-item>评论管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">


          <el-form-item label="用户昵称" prop="nickName">
            <el-input size="small" style="width: 200px;" v-model="formInline.nickName" placeholder="用户昵称"></el-input>
          </el-form-item>

          <el-form-item label="课程标题" prop="courseId">
            <el-select v-model="formInline.courseId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审核结果" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择类型">
              <el-option label="待审核" :value = 0></el-option>
              <el-option label="通过" :value = 1 ></el-option>
              <el-option label="拒绝" :value = 2 ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList(1)" >搜索</el-button>
            <el-button size="small" type="danger" @click="handlePlDel" >批量删除</el-button>
            <el-button size="small" type="primary" @click="handlePlSt(1)" >批量通过</el-button>
            <el-button size="small" type="danger" @click="handlePlSt(2)" >批量拒绝</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }"  @selection-change="handleSelectionChangeDel">


          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="openId" label="用户ID" align="center"></el-table-column>
          <el-table-column prop="nickName" label="用户昵称" align="center"></el-table-column>

          <el-table-column prop="avatar" label="用户头像" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.avatar != null && scope.row.avatar != ''">
                <el-popover placement="top-start" trigger="hover">
                  <a :href="scope.row.avatar" target="_blank" title="查看最大化图片"><img :src="scope.row.avatar" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.avatar" style="width: 100px;height: 100px; cursor:pointer" />
                </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="content" label="评论" align="center"></el-table-column>

          <el-table-column prop="courseId" label="课程标题" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.courseId | getCate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="hf" label="回复数量" align="center"></el-table-column>
          <el-table-column prop="dz" label="点赞数" align="center"></el-table-column>



          <el-table-column prop="status" label="审核结果" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0">待审核</div>
              <div v-if="scope.row.status == 1">通过</div>
              <div v-if="scope.row.status == 2">拒绝</div>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="createTime" label="时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.status == 0" type="success" @click="shData(scope.row,1)"style="width: 100px;margin: 1px;">通过</el-button>
              <el-button size="mini" v-if="scope.row.status == 0" type="success" @click="shData(scope.row,2)"style="width: 100px;margin: 1px;">拒绝</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>







      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryCourseInfo, qryComment, upComment, delComment,delCommentPl,upDomCommentPl} from '../../api/couApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";
var cateDate = [];

export default {
  name: "userList",
  filters:{
    getCate(v){
      var name = '';
      cateDate.forEach((item,index)=>{
        if(item.id == v) name = item.name
      })
      return name
    },
  },

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        nickName:'',
        courseId:'',
        status:'',
        page:1,
        pageSize:10
      },
      listData:[],
      cateList:[],
      multipleSelection:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        status:'',
      },

    }
  },
  mounted() {
    this.tableList();
    this.qryxl();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryComment(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    qryxl(){
      qryCourseInfo({pageSize:1000,cateId:''}).then(res => {
        this.cateList = res.data.list;
        cateDate = res.data.list;
      })
    },

    resetFrom(){
      this.formInline.nickName = '';
      this.formInline.courseId = '';
      this.formInline.status = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },




    deleteData(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delComment(row)
                .then(res => {
                  if (res.code==1) {
                    this.$message({
                      type: 'success',
                      message: '数据已更新!'
                    })
                    this.tableList(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.$message.error('数据删除失败，请稍后再试！')
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
    },


    shData(row,e) {
      this.$confirm('确定要审核吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            var date = {
              id:row.id,
              status:e,
            }
            upComment(date)
                .then(res => {
                  if (res.code==1) {
                    this.$message({
                      type: 'success',
                      message: '数据已更新!'
                    })
                    this.tableList(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.$message.error('数据失败，请稍后再试！')
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消！'
            })
          })
    },


    handleSelectionChangeDel(val){
      this.multipleSelection = val;
    },

    handlePlDel() {
      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }
      this.isDisabled = true;
      var data = {
        ids:this.multipleSelection.map(element=>element.id)
      }
      this.$refs.tabs.clearSelection();
      delCommentPl(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList();
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },



    handlePlSt(e) {

      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }

      this.$confirm('确定要批量审核吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            this.multipleSelection = this.multipleSelection.filter(item => item.status === 0);
            var date = {
              ids:this.multipleSelection.map(element=>element.id),
              status:e,
            }
            upDomCommentPl(date)
                .then(res => {
                  if (res.code==1) {
                    this.$message({
                      type: 'success',
                      message: '数据已更新!'
                    })
                    this.tableList(this.formInline)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.$message.error('数据失败，请稍后再试！')
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消！'
            })
          })
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/cou/ccomment.vue